import moment from 'moment'

export function formatStartDate(date: string): string {
  return moment.utc(date).startOf('day').toISOString()
}

export function formatEndDate(date: string): string {
  return moment.utc(date).endOf('day').toISOString()
}
